// extracted by mini-css-extract-plugin
module.exports = {"small":"ButtonSizes_small__DSl8H","large":"ButtonSizes_large__vTcL3"};